import { Injectable } from '@angular/core';
import { HttpRequestService } from '../http/http-request.service';
import { Observable } from 'rxjs';
import { GithubIntegrationModel } from 'src/app/shared/models/github-integration-model';

@Injectable({
  providedIn: 'root'
})
export class UserGithubIntegrationDetailService {

  private stateUrl = 'api/v1/github-integration-detail';

  constructor(
    private httpRequest: HttpRequestService
  ) { }

  addGithubIntegrationDetail(githubIntegrationModel: GithubIntegrationModel): Observable<any> {
    return this.httpRequest.post(this.stateUrl + '/add-project-integration', githubIntegrationModel);
  }

  updateGithubIntegrationDetail(githubIntegrationModel: GithubIntegrationModel): Observable<any> {
    return this.httpRequest.put(this.stateUrl + '/update-project-integration', githubIntegrationModel);
  }

  checkIntegrationExist(projectId:number): Observable<any> {
    return this.httpRequest.get(this.stateUrl + '/check-integration-exist/'+projectId);
  }

  /**
   * common service for get list of integration list corresponding to project
   * @param projectId 
   */
  fetchIntegrationDetails(projectId:number): Observable<GithubIntegrationModel> {
    return this.httpRequest.get(this.stateUrl + '/fetch-integration-details/'+projectId);
  }

}
